module.exports = __webpack_public_path__ + "img/plan-service-icon2.14f21c56.png";